export default __webpack_public_path__ + "static/media/A0001.5ce30629.png";